import React from 'react';
import Icon from './Icon';
import { INDUSTRIES } from '../data/content';

export default function Industries() {
  return (
    <section id="industries" className="section section-alt">
      <div className="container">
        <div className="section-header reveal">
          <span className="eyebrow">Industries We Serve</span>
          <h2 className="section-title">Purpose-Built Solutions for Every Sector</h2>
          <p className="section-subtitle">
            Our consultants bring domain expertise across the industries that need technology most.
          </p>
        </div>

        <div className="industries-grid">
          {INDUSTRIES.map((ind, i) => (
            <div className="industry-card reveal" key={ind.title} style={{ transitionDelay: `${i * 0.05}s` }}>
              <div className="industry-icon">
                <Icon name={ind.icon} size={24} />
              </div>
              <h4>{ind.title}</h4>
              <p>{ind.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}